import React, { useState, useEffect, useRef } from 'react';
import { get_BOTTOM_SHEET_HEIGHT, set_BOTTOM_SHEET_HEIGHT, set_MAX_Y, set_MID_Y } from './MobileBottomSheetOption.js';
import styled from 'styled-components';
import { motion } from "framer-motion";
import useBottomSheet from './useBottomSheet.ts';
import Header from './Header.tsx';
import HotpleContents from '../Common/Contents/Hotple/HotpleContents.js';
import HomeContents from '../Common/Contents/Home/HomeContents.js';
import ShopContents from '../Common/Contents/Shop/ShopContents.js';

const Wrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  
  position: fixed;
  z-index: 300;
  top: calc(100% - 116px);
  left: 0;
  right: 0;

  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  height: ${get_BOTTOM_SHEET_HEIGHT()}px;
  background: white;
  box-shadow: 0px -4px 4px rgba(0, 0, 0, 0.1);

  transition: transform 150ms ease-out;
`

const BottomSheetContent = styled.div`
  overflow: auto;
  -webkit-overflow-scrolling: touch;
`

function BottomSheet({ activeMenu, setActiveMenu, setUserModalPage, setAuthModalPage, setInfoModalPage, setTutorialModalPage, notices, account, recommendHotples, myHotples, rangeHotples, mapHotples, adminHotples, updateHotpleInfo, mapLocation, isSearchMode, setIsSearchMode, selectedHotple, setSelectedHotple, selectedOption, setSelectedOption, fcmToken, setModalProps, hotThreshold, shopItems, setIsHotModalShown, devicePosition, setAnlysisPageHotple}) {
  const mobileHotpleRefs = useRef({}); 
  const prevHeight = useRef(370); // 이전 값을 저장할 ref
  const prevHotpleId = useRef(null);
  const [stickyFilter, setStickyFilter] = useState(true);
  const [isInitialized, setIsInitialized] = useState(false);
  const { sheet, content, setBottomSheetPosition } = useBottomSheet(setSelectedHotple, setStickyFilter);

  useEffect(() => {
		if(isSearchMode)
      setBottomSheetPosition("min");
	}, [isSearchMode])

  useEffect(() => {
    if (selectedHotple) {
      prevHotpleId.current = selectedHotple.hotple_id;

      if(content.current){
        const contentsHeight = content.current.offsetHeight;
        setBottomSheetPosition("mid", contentsHeight);
        prevHeight.current=contentsHeight;
      }
    }
    else{
      if(sheet.current && content.current){
        if (prevHotpleId.current) {
          const prevElement = mobileHotpleRefs.current[prevHotpleId.current];
          if (prevElement) {
            prevElement.scrollIntoView({
              behavior: 'instant',
              block: 'start'
            });
          }
        }

        if(sheet.current!.getBoundingClientRect().y < window.outerHeight - prevHeight.current - 70)
          setBottomSheetPosition("max");
        else
          setBottomSheetPosition("min");

        prevHeight.current=0;
      }
    }
	}, [selectedHotple])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const hotpleId = params.get('hotple_id');
    const menu = params.get('menu');

    prevHotpleId.current = null;
    if (content.current) {
      content.current.scrollTo({ top: 0, behavior: 'instant' }); // 🔥 스크롤을 최상단으로 이동
    }

		if(activeMenu=="home" && !menu && !hotpleId){
      setIsInitialized(true);
      setTimeout(() => {
        setBottomSheetPosition("max");
      }, isInitialized?50:300);
    }
    else if(activeMenu=='shop'){
      setBottomSheetPosition("max");
    }
	}, [activeMenu])

  useEffect(()=>{
    setTimeout(() => {
      set_MAX_Y(window.innerHeight);
      set_MID_Y(window.innerHeight);
      set_BOTTOM_SHEET_HEIGHT(window.innerHeight);
      
      if (sheet.current) {
        sheet.current.style.height = `${get_BOTTOM_SHEET_HEIGHT()}px`;
      }
    }, 300);
  },[])

  return (
    <Wrapper ref={sheet}>
      <Header activeMenu={activeMenu} rangeHotples={rangeHotples} myHotples={myHotples} adminHotples={adminHotples} selectedOption={selectedOption} setSelectedOption={setSelectedOption} selectedHotple={selectedHotple} stickyFilter={stickyFilter}/>
      <BottomSheetContent ref={content} id='hotpleitems-container'>
        {activeMenu=='home' &&
          <HomeContents setUserModalPage={setUserModalPage} setAuthModalPage={setAuthModalPage} setInfoModalPage={setInfoModalPage} setTutorialModalPage={setTutorialModalPage} activeMenu={activeMenu} setActiveMenu={setActiveMenu} setSelectedOption={setSelectedOption} selectedOption={selectedOption} notices={notices} account={account} recommendHotples={recommendHotples} myHotples={myHotples} mapHotples={mapHotples} updateHotpleInfo={updateHotpleInfo} selectedHotple={selectedHotple} setSelectedHotple={setSelectedHotple} fcmToken={fcmToken} setModalProps={setModalProps} hotThreshold={hotThreshold} mobileHotpleRefs={mobileHotpleRefs} devicePosition={devicePosition} setAnlysisPageHotple={setAnlysisPageHotple}/>
        }
        {(activeMenu=='search' || activeMenu=='my' || activeMenu=='admin') &&
          <HotpleContents activeMenu={activeMenu} setActiveMenu={setActiveMenu} setUserModalPage={setUserModalPage} setAuthModalPage={setAuthModalPage} setInfoModalPage={setInfoModalPage} setTutorialModalPage={setTutorialModalPage} notices={notices} account={account} myHotples={myHotples} rangeHotples={rangeHotples} mapHotples={mapHotples} adminHotples={adminHotples} updateHotpleInfo={updateHotpleInfo} mapLocation={mapLocation} setIsSearchMode={setIsSearchMode} selectedHotple={selectedHotple} setSelectedHotple={setSelectedHotple} selectedOption={selectedOption} setSelectedOption={setSelectedOption} fcmToken={fcmToken} setModalProps={setModalProps} hotThreshold={hotThreshold} mobileHotpleRefs={mobileHotpleRefs} devicePosition={devicePosition} setAnlysisPageHotple={setAnlysisPageHotple}/>
        }
        {activeMenu=='shop' &&
          <ShopContents shopItems={shopItems} selectedOption={selectedOption} setSelectedOption={setSelectedOption} account={account} setIsHotModalShown={setIsHotModalShown} setAuthModalPage={setAuthModalPage} setModalProps={setModalProps} setInfoModalPage={setInfoModalPage}/>
        }
      </BottomSheetContent>
    </Wrapper>
  );
}

export default BottomSheet;